var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navbar-brand"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(" プロセカ Station ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }